import "./App.css";
import { BrowserRouter } from "react-router-dom";
import MainRoutes from "./pages/Router/MainRoutes";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <MainRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
